export default __webpack_public_path__ + "static/media/PCBAssembly.a7bafd1f.svg";